import { AxiosResponse } from 'axios';
import AxiosInstance from './AxiosInstance';

export const addGroupOwner = async (roomId: string, userId: string): Promise<AxiosResponse> =>
  AxiosInstance.post('groups.addOwner', { roomId, userId });
